<div class="toggleable" [class.toggled]="toggled">
  <div
    class="header"
    [class.pointer]="entireHeaderClickable()"
    (click)="entireHeaderClickable() && toggle()"
  >
    <ng-content select="[header]"></ng-content>

    <i
      class="fal pointer"
      [class.fa-chevron-down]="!toggled"
      [class.fa-chevron-up]="toggled"
      (click)="!entireHeaderClickable() && toggle()"
    ></i>
  </div>
  @if (toggled) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
</div>
